//
export default theme => ({
  primary: { main: '#ED154E' },
  secondary: { main: '#232323' },
})
